/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import _ from 'lodash';
import * as ActionTypes from './actionTypes';

export const dispatchPlanType = (data) => ({
  type: ActionTypes.GET_PLAN_TYPE_DATA,
  payload: data,
});

//Loader
export const setLoading = (value) => ({
  type: ActionTypes.IS_LOADING_MANNUFACTURER_SUMMERY,
  isLoading: value,
});

export const refresgManufacturerSummary = () => ({
  type: ActionTypes.REFRESH_MANUFACTURE_SUMMARY,
  payload: {},
});

export const refresgManufacturerSummaryDisplay = (data) => ({
  type: ActionTypes.REFRESH_MANUFACTURE_SUMMARY_DISPLAY,
  payload: data,
});

export const getPlanTypeValues = () => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(dispatchPlanType([]));
    });
};

//API to get Reabte Program List
export const getRebateProgrameList = (value) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      dispatch(setLoading(false));
      return response.data.data;
    })
    .catch((response) => {
      dispatch(setLoading(false));
    });
};

export const setSearchInput = (data) => ({
  type: ActionTypes.SET_SEARCH_INPUT_MANUFACTURER_SUMMRARY,
  payload: data,
});

//Manufacturer Grid
export const getManufacturerList = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.MANUFACTURER_SUMMARY_GRID}`, values)
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch({
        type: ActionTypes.GET_MANUFACTURER_LIST_MANUFACTURER_SUMMARY,
        payload: response?.data?.manufacturerSummaryMfgGridVO,
      });
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch({
        type: ActionTypes.GET_MANUFACTURER_LIST_MANUFACTURER_SUMMARY,
        payload: [],
      });
      return response;
    });
};
export const setManufactureSummaryReport = (data) => ({
  type: ActionTypes.GET_RESULT_MANUFACTURER_SUMMARY,
  payload: data,
});
//Result Grid api call
export const getResultManufacturerSummary = (values) => (dispatch) => {
  dispatch(setLoading(true));
  // dispatch(setManufactureSummaryReport({}));
  return axios
    .post(`${serviceEndPoint.GET_MANUFACTURE_SUMMARY_REPORT_GRID}`, values)
    .then((response) => {
      dispatch(setLoading(false));

      dispatch(
        setManufactureSummaryReport(response?.data?.manufactureSummaryAllListVO)
      );
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch({
        type: ActionTypes.GET_RESULT_MANUFACTURER_SUMMARY,
        payload: [],
      });
    });
};

//Manufacturer summary dispute ammount data api call
export const getDisputeAmount = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(
      `${serviceEndPoint.GET_MANUFACTURE_SUMMARY_DISPUTEAMOUNT_FOR_QUARTER}`,
      values
    )
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch({
        type: ActionTypes.GET_DISPUTE_AMOUNT_FOR_QUARTER,
        payload:
          response?.data?.manufactureSummaryDisputeAmountForQuarterVOList,
      });
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch({
        type: ActionTypes.GET_DISPUTE_AMOUNT_FOR_QUARTER,
        payload: [],
      });
      return response;
    });
};

//Set balance thresh

export const setBalanceThresh = (data) => ({
  type: ActionTypes.SET_BALANCE_THRESH,
  payload: data,
});

export const getBalanceThreshold = (value) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.DISPUTE_AMOUNT_THRESHOLD}`, value)
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch(
        setBalanceThresh(
          response?.data?.balanceDueThresholdVO.rptBalanceDueThreshold
        )
      );
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setBalanceThresh([]));
    });
};
//dispatch DRAMS

export const dispatchDRAMS = (data) => ({
  type: ActionTypes.GET_DRAMS_INVOICE_START_QUARTER_VALUE,
  payload: data,
});

//get DRAMS Quarter

export const getDramsInvStartQtr = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_DRAMS_INVOICE_START_QUARTER, value)
    .then((response) => {
      return dispatch(dispatchDRAMS(response?.data?.dramsInvoiceStartQuarter));
    })
    .catch((response) => {
      dispatch(dispatchDRAMS(''));
    });
};

//dispatch Earliest Qtr

export const dispatchEarliestDrugQtr = (data) => ({
  type: ActionTypes.GET_EARLIEST_QTR_DRUG_VALUE,
  payload: data,
});

//get Earliest Drag Quarter

export const getEarliestDrugQtr = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_EARLIEST_QTR_DRUG, value)
    .then((response) => {
      return dispatch(
        dispatchEarliestDrugQtr(
          response?.data?.earliestQtrForDrugDetailsVO?.defEarliestQtrForDrugDtls
        )
      );
    })
    .catch((response) => {
      dispatch(dispatchEarliestDrugQtr(''));
    });
};
